//sidebar
export const TOGGLE = "TOGGLE"

//theme
export const TOGGLE_THEME = "TOGGLE_THEME"
